/* global axios */
import ApiClient from './ApiClient';

class TaxiPartnersAPI extends ApiClient {
  constructor() {
    super('taxi_partners', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { taxi_partner: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { taxi_partner: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  createTrip(partnerId, data) {
    return axios.post(`${this.url}/${partnerId}/trips`, {
      taxi_partner_trip: data,
    });
  }

  deleteTrip(partnerId, tripId) {
    return axios.delete(`${this.url}/${partnerId}/trips/${tripId}`);
  }
}

export default new TaxiPartnersAPI();
